<script setup lang="ts">
import { computed } from 'vue'
import { Dialog } from 'frappe-ui'
import { dirtyGuardDialogState } from '../composables/useDirtyGuard'

const props = defineProps<{
  modelValue: boolean
}>()

const emit = defineEmits<{
  'update:modelValue': [value: boolean]
}>()

// Closing by Escape / overlay counts as "keep editing".
const open = computed({
  get: () => props.modelValue,
  set: (v: boolean) => {
    if (!v && props.modelValue) dirtyGuardDialogState.confirm(false)
    emit('update:modelValue', v)
  },
})

function handleConfirm(discard: boolean) {
  dirtyGuardDialogState.confirm(discard)
  emit('update:modelValue', false)
}
</script>

<template>
  <Dialog
    v-model:open="open"
    title="Discard unsaved changes?"
    :actions="[
      {
        label: 'Keep editing',
        variant: 'ghost',
        onClick: () => handleConfirm(false),
      },
      {
        label: 'Discard changes',
        theme: 'red',
        onClick: () => handleConfirm(true),
      },
    ]"
    size="md"
  >
    <p class="text-p-base text-ink-gray-7">
      {{ dirtyGuardDialogState.message }}
    </p>
  </Dialog>
</template>
